export const LIST_DOMAIN = 'LIST_DOMAIN';
export const LIST_VERIFIED_DOMAIN = 'LIST_VERIFIED_DOMAIN';
export const VERIFY_DOMAIN = 'VERIFY_DOMAIN';
export const MARK_DEFAULT_DOMAIN = 'MARK_DEFAULT_DOMAIN';
export const REMOVE_DEFAULT_DOMAIN = 'REMOVE_DEFAULT_DOMAIN';
export const DELETE_DOMAIN = 'DELETE_DOMAIN';
export const CREATE_DOMAIN = 'CREATE_DOMAIN';
export const RELOAD_DOMAIN = 'RELOAD_DOMAIN';